var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHiwRightArrow = function SvgHiwRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.375 4.414H1.625M17.25 7.54l3.125-3.126L17.25 1.29",
    stroke: "#F39237",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgHiwRightArrow;